<div [formGroup]="form">
  <div class="flex gap-8">
    <div style="width: 400px">
      <div class="control required">
        <label>Navn</label>
        <input pInputText formControlName="navn" />
        @if (form.controls['navn'].errors &&
        form.controls['navn'].touched) {
          <p class="error">Feltet skal udfyldes</p>
        }
      </div>
      <div class="control">
        <label>Stilling</label>
        <input pInputText formControlName="stilling" />
      </div>
      <div class="control">
        <label>Tlf</label>
        <input pInputText formControlName="tlf" />
      </div>
      <div class="control">
        <label>Email</label>
        <input pInputText formControlName="email" />
      </div>
      <div class="control">
        <label>Rækkefølge</label>
        <input pInputText formControlName="sekvensNr" />
      </div>

    </div>
    <div>
      <div class="control">
        <label>Billede</label>
        @if (getBillede()) {
          <img [src]="getBillede()" alt="billede" style="max-height: 322px" />
        }
        <br />
        <p-fileupload #uploader
                      mode="basic"
                      chooseLabel="Vælg fil"
                      chooseIcon="pi pi-upload"
                      accept="image/*"
                      maxFileSize="1000000"
                      (onSelect)="onFileSelect($event)"
                      class="let-fileupload-leftaligned"
        />

      </div>
    </div>
  </div>

  <div class="flex gap-4">
    <p-button
      label="Gem ændringer"
      icon="pi pi-save"
      (click)="onClickSave()"
      [disabled]="!form.valid"
    />
    <p-button
      label="Slet medarbejder"
      icon="pi pi-trash"
      severity="danger"
      outlined
      (click)="onClickDelete($event)"
    />
  </div>

</div>
<p-confirmDialog />
